import { GroupAction, GroupActionTypes, GroupState } from "./groupTypes";

const initialState: GroupState = {
  selected: true,
  list: [],
  group: {
    createdAt: "2020-08-21T02:27:55.804Z",
    id: 0,
    logoPhotoFile: {
      contentType: "",
      id: 0,
      name: "",
      relateType: "GROUP",
      relateTypeId: 0,
      url: "",
    },
    logoPhotoFileId: 0,
    name: "",
  },
};

const groupReducer = (state = initialState, action: GroupAction) => {
  switch (action.type) {
    case GroupActionTypes.GET_GROUP_LIST:
      return { ...state, list: action.payload };
    case GroupActionTypes.POST_ID_TO_SWITCH_GROUP:
      return { ...state, ...action.payload };
    case GroupActionTypes.SET_SELECTED:
      return { ...state, selected: action.payload };
    default:
      return state;
  }
};

export default groupReducer;
